import {initElements} from "../define/shared";

export default function initFaqCategory() {
    initElements(".singleFaqCategory", category => {

        fetch(window.RES.base + "wa-theme/v1/faq-category-counter", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                'X-WP-Nonce': window.RES.nonce_wp,
            },
            body: JSON.stringify({
                term: category.dataset.term,
                nonce: window.RES.nonce
            })
        }).then(response => response.json())
          .then(data => {
                console.log(data);
            });
    });
}
